Auth = require 'db/auth'
campaigns = require 'data/marketing-campaign-boards'
CopyBoardView = require 'views/board/copy-board-view'
Keys = require 'data/keys'
Keyboard = require 'lib/keyboard'
PopOver = require 'views/lib/pop-over'
template = require 'views/templates/logged_in_public_board_banner'
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
WarningBannerView = require 'views/header/warning-banner-view'

module.exports = class LoggedInPublicBoardBannerView extends WarningBannerView
  className: ->
    trelloForTeams = if @model.id in campaigns.TRELLO_FOR_TEAMS then 'trello-for-teams' else ''
    "header-banner mod-warning logged-in-public-board-banner #{trelloForTeams}"

  initialize: ->
    super

    @isHidden = false
    @listenTo @model, 'change', @frameDebounce @render

  events:
    'keydown': 'keydownEvent'
    'click .js-close-banner': 'dismiss'
    'click .js-learn-more': 'trackHelp'
    'click .js-copy-board': 'copyBoard'

  dismissalKey: -> "logged-in-public-board-#{@model.get('id')}"

  dismiss: ->
    @isHidden = true
    Auth.me()?.dismissAd(@dismissalKey())
    @render()
    trackUe('public board', 'dismisses', 'reminder banner', '', '', 'by clicking close icon', { boardid: @model.get('id') })

  isDismissed: ->
    Auth.me()?.isAdDismissed(@dismissalKey())

  trackHelp: ->
    trackUe('public board', 'opens', 'help', '', '', 'by clicking link in reminder banner', { boardid: @model.get('id') })

  keydownEvent: (e) ->
    key = Keyboard.getKey(e)

    if key == Keys.Enter
      if @$(e.target).hasClass('js-learn-more')
        @trackHelp()

      @$('.js-learn-more')
      return

  copyBoard: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$(e.target).closest('.js-copy-board')
      view: new CopyBoardView({ @model, @modelCache })

  render: ->
    isVisible = !@isHidden && !@isDismissed() && @model?.isPublic() && !@model?.get('closed')
    if isVisible
      trackUe('public board', 'displays', 'reminder banner', '', '', 'by viewing board', { boardid: @model.get('id') })

    @$el.toggleClass('hide', !isVisible)
    @$el.html template({
      isAdmin: @model?.owned(),
      trelloForTeams: @model.id in campaigns.TRELLO_FOR_TEAMS,
      isVisible
    })

    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/logged-in-public-board-banner-view.coffee